/**
 * Gordonix: ana oynatıcı = seçili varyant | Yakından bak = ana medya
 * Map: dosya/alt öneki v1-…v99- = varyant pozisyonu; genel-/öneksiz = overview
 * Geçiş: skeleton | Thumb/zoom: seçimi koru | Lightbox: şerit + swipe
 */
(function () {
  function gordonixForceEagerVisible(root) {
    try {
      const scope = root || document.querySelector("media-gallery") || document;
      // Sadece ilk görünür slayt — tüm img eager = sayfa kilitlenmesi
      const imgs = [
        ...scope.querySelectorAll(
          'slideshow-slide[data-gordonix-show="1"] img, slideshow-slide[aria-hidden="false"] img'
        ),
      ].slice(0, 2);
      imgs.forEach((img) => {
        if (img.loading === "lazy") img.loading = "eager";
        if ("fetchPriority" in img) img.fetchPriority = "high";
      });
    } catch (e) {}
  }

  function gordonixVisibleImgsReady() {
    try {
      const imgs = [
        ...document.querySelectorAll(
          'media-gallery slideshow-slide[data-gordonix-show="1"] img, media-gallery slideshow-slide:not([hidden]):not(.gordonix-slide-hide) img, media-gallery slideshow-slide[aria-hidden="false"] img'
        ),
      ];
      if (!imgs.length) return false;
      return imgs.every((img) => img.complete && img.naturalWidth > 0);
    } catch (e) {
      return false;
    }
  }

  function isMobileViewport() {
    try {
      return window.matchMedia("(max-width: 749px)").matches;
    } catch (e) {
      return false;
    }
  }

  let lockedVariantId = null;
  let lastAppliedId = null;
  let selectedMediaId = null;
  let applyToken = 0;
  let switchToken = 0;
  let switching = false;
  let galleryObserver = null;
  let bootstrapped = false;
  let lookItems = [];
  let lookIndex = 0;
  let morphTimer = null;
  let skeletonTimer = null;
  let counterSyncing = false;
  let lastFilterKey = "";
  let lastSingle = null;
  let applyingFilter = false;
  let counterTimer = null;

  function parseMap() {
    const el = document.querySelector("[data-gordonix-gallery-map]");
    if (!el) return { overview: [], variants: {}, singleVariant: false, firstVariantId: null };
    try {
      return JSON.parse(el.textContent || "{}");
    } catch {
      return { overview: [], variants: {}, singleVariant: false, firstVariantId: null };
    }
  }

  // Tıklanan seçeneğin varyantı; form input'u sunucu yanıtı gelene kadar eski değeri tutar
  let pendingVariantId = null;
  let pendingVariantAt = 0;

  function inputVariantId() {
    const input =
      document.querySelector('product-form-component input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function currentVariantId() {
    const live = inputVariantId();
    if (pendingVariantId) {
      if (live === pendingVariantId || Date.now() - pendingVariantAt > 6000) {
        pendingVariantId = null;
      } else {
        return pendingVariantId;
      }
    }
    return live;
  }

  function galleryEls() {
    return [...document.querySelectorAll("media-gallery")];
  }

  function markReady() {
    document.documentElement.classList.add("gordonix-gallery-bootstrapped");
    galleryEls().forEach((el) => el.classList.add("gordonix-gallery-ready"));
  }

  function ensureSkeleton(gallery) {
    let sk = gallery.querySelector(":scope > .gordonix-gallery-skeleton");
    if (sk) return sk;
    sk = document.createElement("div");
    sk.className = "gordonix-gallery-skeleton";
    sk.setAttribute("aria-hidden", "true");
    sk.innerHTML =
      '<div class="gordonix-gallery-skeleton__layout">' +
      '<div class="gordonix-gallery-skeleton__main"></div>' +
      '<div class="gordonix-gallery-skeleton__thumbs">' +
      "<span></span><span></span><span></span><span></span>" +
      "</div>" +
      "</div>";
    if (getComputedStyle(gallery).position === "static") {
      gallery.style.position = "relative";
    }
    gallery.appendChild(sk);
    return sk;
  }

  let switchLockUntil = 0;

  function lockSwitch(ms) {
    switchLockUntil = Date.now() + (ms || 900);
  }

  function isSwitchLocked() {
    return Date.now() < switchLockUntil;
  }

  function showSkeleton() {
    // Eski görseller hâlâ “ready” olsa bile skeleton göster — yoksa eski kare kalır
    switching = true;
    lockSwitch(1000);
    clearTimeout(skeletonTimer);
    galleryEls().forEach((g) => {
      const sk = ensureSkeleton(g);
      g.classList.add("gordonix-has-skeleton");
      void sk.offsetWidth;
      sk.classList.add("is-visible");
    });
    skeletonTimer = setTimeout(() => {
      forceClearSkeleton();
    }, 800);
  }

  function hideSkeleton() {
    switching = false;
    clearTimeout(skeletonTimer);
    galleryEls().forEach((g) => {
      const sk = g.querySelector(":scope > .gordonix-gallery-skeleton");
      if (sk) {
        sk.classList.remove("is-visible");
        sk.classList.remove("is-hiding");
      }
      g.classList.remove("gordonix-has-skeleton");
    });
    markReady();
  }

  function forceClearSkeleton() {
    // Scroll/morph sonrası takılı skeleton'ı temizle — kaydırırken filtreleme yapma
    switching = false;
    clearTimeout(skeletonTimer);
    document.querySelectorAll("media-gallery").forEach((g) => {
      g.classList.remove("gordonix-has-skeleton");
      g.classList.add("gordonix-gallery-ready");
      const sk = g.querySelector(".gordonix-gallery-skeleton");
      if (sk) {
        sk.classList.remove("is-visible");
        sk.classList.remove("is-hiding");
      }
    });
    document.documentElement.classList.add("gordonix-gallery-bootstrapped");
  }

  function slideNodes() {
    return [
      ...document.querySelectorAll(
        "media-gallery slideshow-slide[data-gordonix-media-id]"
      ),
    ];
  }

  function gridNodes() {
    return [
      ...document.querySelectorAll(
        "media-gallery li[data-gordonix-media-id], media-gallery [ref='media[]'][data-gordonix-media-id]"
      ),
    ].filter((n) => n.tagName !== "SLIDESHOW-SLIDE");
  }

  function zoomMediaNodes() {
    return [
      ...document.querySelectorAll(
        "zoom-dialog li[data-gordonix-media-id], .dialog-zoomed-gallery > li[data-gordonix-media-id]"
      ),
    ];
  }

  function thumbnailNodes() {
    return [
      ...document.querySelectorAll(
        "media-gallery .slideshow-controls__thumbnail[data-gordonix-media-id], media-gallery .dialog-thumbnails-list__thumbnail[data-gordonix-media-id], .dialog-thumbnails-list__thumbnail[data-gordonix-media-id], zoom-dialog .dialog-thumbnails-list__thumbnail[data-gordonix-media-id]"
      ),
    ];
  }

  function mediaImgForId(id) {
    const slide =
      document.querySelector(
        'media-gallery slideshow-slide[data-gordonix-media-id="' + id + '"]'
      ) ||
      document.querySelector(
        'media-gallery [data-gordonix-media-id="' + id + '"]'
      );
    if (!slide) return null;
    const img = slide.querySelector("img");
    if (!img) return null;
    const full =
      img.currentSrc ||
      img.src ||
      img.getAttribute("src") ||
      img.getAttribute("data-src") ||
      "";
    const w = img.naturalWidth || Number(img.getAttribute("width")) || 0;
    const h = img.naturalHeight || Number(img.getAttribute("height")) || 0;
    return { thumb: full, full: full.replace(/width=\d+/i, "width=2000"), w, h };
  }

  function setThumbVisible(thumb, show) {
    thumb.classList.toggle("gordonix-thumb-hide", !show);
    thumb.hidden = !show;
    if (show) {
      thumb.style.removeProperty("display");
      thumb.removeAttribute("aria-hidden");
    } else {
      thumb.style.setProperty("display", "none", "important");
      thumb.setAttribute("aria-hidden", "true");
    }
  }

  function setSlideVisible(node, show) {
    const isSlide = node.tagName === "SLIDESHOW-SLIDE";
    const mobile = isMobileViewport();
    if (show) {
      node.setAttribute("data-gordonix-show", "1");
      node.classList.remove("gordonix-slide-hide");
      node.style.removeProperty("display");
      node.removeAttribute("hidden");
      node.removeAttribute("reveal");
      // Aktif slaytı select belirler; hepsini false yapınca üst üste binme / eski kare kalır
      node.setAttribute("aria-hidden", "true");
    } else {
      node.setAttribute("data-gordonix-show", "0");
      node.classList.add("gordonix-slide-hide");
      node.setAttribute("hidden", "");
      node.setAttribute("aria-hidden", "true");
      node.removeAttribute("reveal");
      // Mobil: display:none galeri yüksekliğini sıfırlar → sayfa yukarı zıplar
      if (!(mobile && isSlide)) {
        node.style.setProperty("display", "none", "important");
      } else {
        node.style.removeProperty("display");
      }
    }
  }

  function variantImageIds(variantId) {
    const map = parseMap();
    const norm = (v) => String(v || "").replace(/^gid:\/\/shopify\/(ProductVariant|MediaImage|ProductImage)\//, "");
    if (map.singleVariant) {
      // Tek varyant: overview + v1 birleşik (sadece genel yetmez; v1 kapak da görünsün)
      const overview = (map.overview || []).map(norm).filter(Boolean);
      const vids = Object.values(map.variants || {})[0] || [];
      const merged = [...overview];
      for (const id of vids.map(norm).filter(Boolean)) {
        if (!merged.includes(id)) merged.push(id);
      }
      return merged.length ? merged : overview;
    }

    const id = norm(variantId || currentVariantId());
    if (!id) return [];

    const variants = map.variants || {};
    let ids = variants[id];
    if (!ids) {
      // GID / string anahtar uyumsuzluğuna karşı tara
      const key = Object.keys(variants).find((k) => norm(k) === id);
      if (key) ids = variants[key];
    }
    if (ids && ids.length) return ids.map(norm).filter(Boolean);

    // Çoklu varyantta overview'a ASLA düşme (tüm medya görünür hale geliyordu)
    return [];
  }

  function syncCounter() {
    const visible = slideNodes().filter(isSlideShown);
    const total = visible.length;
    document.querySelectorAll("media-gallery .slideshow-controls__counter").forEach((counter) => {
      let totalEl = counter.querySelector("[data-gordonix-total]");
      if (!totalEl) {
        // Slash sonrası statik "12" metnini bizim span ile değiştir
        [...counter.childNodes].forEach((n) => {
          if (n.nodeType === 3) n.textContent = "";
        });
        totalEl = document.createElement("span");
        totalEl.setAttribute("data-gordonix-total", "");
        const slash = counter.querySelector(".slash");
        if (slash) slash.after(totalEl);
        else counter.appendChild(totalEl);
      }
      totalEl.textContent = String(Math.max(total, 1));

      // current: görünür slaytlar içinde sıra
      const currentEl = counter.querySelector('[ref="current"]');
      if (currentEl && total > 0) {
        let idx = visible.findIndex(
          (s) => s.getAttribute("aria-hidden") === "false"
        );
        if (idx < 0 && selectedMediaId) {
          idx = visible.findIndex(
            (s) =>
              String(s.getAttribute("data-gordonix-media-id")) ===
              String(selectedMediaId)
          );
        }
        if (idx < 0) idx = 0;
        const next = String(idx + 1);
        if (currentEl.textContent !== next) {
          counterSyncing = true;
          currentEl.textContent = next;
          counterSyncing = false;
        }
      }

      const controls = counter.closest("slideshow-controls");
      if (controls) {
        controls.classList.toggle("gordonix-counter-hide", total <= 1);
      }
    });
  }

  function syncSingleMediaUI() {
    const visibleCount = slideNodes().filter(isSlideShown).length;
    const single = visibleCount <= 1;
    if (lastSingle !== single) {
      lastSingle = single;
      document.querySelectorAll("media-gallery").forEach((g) => {
        g.classList.toggle("gordonix-single-media", single);
      });
      document
        .querySelectorAll(
          "media-gallery .slideshow-controls__arrows, media-gallery .slideshow-control--previous, media-gallery .slideshow-control--next, media-gallery button[ref='previous'], media-gallery button[ref='next']"
        )
        .forEach((el) => {
          if (single) {
            el.style.setProperty("display", "none", "important");
            el.setAttribute("aria-hidden", "true");
          } else {
            el.style.removeProperty("display");
            el.removeAttribute("aria-hidden");
          }
        });
    }
    syncCounter();
  }

  function getScroller(ss) {
    if (!ss) return null;
    return (
      ss.querySelector(':scope > [ref="scroller"]') ||
      ss.querySelector("slideshow-slides") ||
      ss.querySelector('[ref="scroller"]')
    );
  }

  function pinPageScroll(fn) {
    const y = window.scrollY || window.pageYOffset || 0;
    try {
      fn();
    } finally {
      if (isMobileViewport() && Math.abs((window.scrollY || 0) - y) > 1) {
        try {
          window.scrollTo(0, y);
        } catch (e) {}
      }
    }
  }

  function hardScrollToSlide(node) {
    if (!node) return;
    const ss = node.closest("slideshow-component");
    const scroller = getScroller(ss);
    if (!scroller) return;
    // Sadece kaydırıcı — scrollIntoView sayfayı galeriye çeker (mobil zıplama)
    try {
      const left = node.offsetLeft - scroller.offsetLeft;
      scroller.scrollLeft = Math.max(0, left);
      scroller.scrollTop = 0;
    } catch (e) {
      try {
        scroller.scrollLeft = 0;
      } catch (err) {}
    }
  }

  // Görünür slaytları map sırasına göre DOM başa al — Horizon index 0 erken çıkışında doğru kare kalsın
  function reorderSlidesByIds(ids) {
    const list = (ids || []).map(normMediaId).filter(Boolean);
    if (!list.length) return;
    const slides = slideNodes();
    if (slides.length < 2) return;
    const parent = slides[0].parentElement;
    if (!parent) return;
    const byId = new Map();
    slides.forEach((s) => {
      const id = normMediaId(s.getAttribute("data-gordonix-media-id"));
      if (id && !byId.has(id)) byId.set(id, s);
    });
    const ordered = [];
    const used = new Set();
    list.forEach((id) => {
      const n = byId.get(id);
      if (n && !used.has(n)) {
        ordered.push(n);
        used.add(n);
      }
    });
    slides.forEach((n) => {
      if (!used.has(n)) ordered.push(n);
    });
    let changed = false;
    for (let i = 0; i < ordered.length; i++) {
      if (slides[i] !== ordered[i]) {
        changed = true;
        break;
      }
    }
    if (!changed) return;
    const frag = document.createDocumentFragment();
    ordered.forEach((n) => frag.appendChild(n));
    parent.appendChild(frag);
  }

  function reorderThumbsByIds(ids) {
    const list = (ids || []).map(normMediaId).filter(Boolean);
    if (!list.length) return;
    document.querySelectorAll("media-gallery .slideshow-controls__thumbnail").forEach((thumb) => {
      // parent bazında grupla
    });
    const groups = new Map();
    thumbnailNodes().forEach((thumb) => {
      const parent = thumb.parentElement;
      if (!parent) return;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(thumb);
    });
    groups.forEach((thumbs, parent) => {
      if (thumbs.length < 2) return;
      const byId = new Map();
      thumbs.forEach((t) => {
        const id = normMediaId(t.getAttribute("data-gordonix-media-id"));
        if (id && !byId.has(id)) byId.set(id, t);
      });
      const ordered = [];
      const used = new Set();
      list.forEach((id) => {
        const n = byId.get(id);
        if (n && !used.has(n)) {
          ordered.push(n);
          used.add(n);
        }
      });
      thumbs.forEach((n) => {
        if (!used.has(n)) ordered.push(n);
      });
      let changed = false;
      for (let i = 0; i < ordered.length; i++) {
        if (thumbs[i] !== ordered[i]) {
          changed = true;
          break;
        }
      }
      if (!changed) return;
      const frag = document.createDocumentFragment();
      ordered.forEach((n) => frag.appendChild(n));
      parent.appendChild(frag);
    });
  }

  function selectSlide(node, attempt, opts) {
    if (!node) return;
    const ss = node.closest("slideshow-component");
    if (!ss || typeof ss.select !== "function") return;
    const slideId = node.getAttribute("slide-id");
    const tries = attempt || 0;
    const force = !!(opts && opts.force);
    try {
      // reveal kalıntısı Horizon'da gizli slaytı tekrar “slides”e sokar
      slideNodes().forEach((s) => {
        if (s !== node) s.removeAttribute("reveal");
      });
      node.removeAttribute("reveal");

      // Horizon: slides[current] === hedef ise select erken çıkar (varyant değişiminde index 0).
      try {
        ss.current = -1;
      } catch (e) {}

      if (slideId) ss.select({ id: slideId }, undefined, { animate: false });
      else if (Array.isArray(ss.slides)) {
        const idx = ss.slides.indexOf(node);
        if (idx >= 0) ss.select(idx, undefined, { animate: false });
      }

      // Her force'ta aria + scroll — select no-op olsa bile doğru kare
      if (force) {
        const visible = slideNodes().filter(isSlideShown);
        visible.forEach((s) => {
          s.setAttribute("aria-hidden", s === node ? "false" : "true");
          if (s !== node) s.removeAttribute("reveal");
        });
        hardScrollToSlide(node);
        try {
          const idx = Array.isArray(ss.slides) ? ss.slides.indexOf(node) : -1;
          if (idx >= 0) ss.current = idx;
        } catch (e) {}
      }
    } catch (e) {}
    // Mobil: az deneme — tekrarlı select sayfayı zıplatır ve geçişi geciktirir
    const maxTries = isMobileViewport() ? 3 : 8;
    if (tries < maxTries) {
      setTimeout(() => {
        if (!node.isConnected || node.getAttribute("data-gordonix-show") !== "1")
          return;
        if (node.getAttribute("aria-hidden") === "false") {
          if (force && tries < 2) hardScrollToSlide(node);
          return;
        }
        selectSlide(node, tries + 1, opts);
      }, isMobileViewport() ? 40 + tries * 30 : 20 + tries * 18);
    }
  }

  function ensureActiveVisibleSlide(opts) {
    const visible = slideNodes().filter(isSlideShown);
    if (!visible.length) return;
    const active = visible.find((s) => s.getAttribute("aria-hidden") === "false");
    if (!active) selectSlide(visible[0], 0, opts);
  }

  /**
   * @param {string[]} ids
   * @param {{ mode?: 'first'|'keep'|'none' }} opts
   * mode:
   *  - first: varyant değişince 1. görsel
   *  - keep: seçili medyayı koru (yoksa 1.)
   *  - none: sadece gizle/göster, select yok (thumb tıklanınca 1.'ye dönmesin)
   */
  function normMediaId(v) {
    return String(v || "").replace(/^gid:\/\/shopify\/(ProductVariant|MediaImage|ProductImage)\//, "");
  }

  function isSlideShown(node) {
    return node.getAttribute("data-gordonix-show") === "1" && !node.classList.contains("gordonix-slide-hide");
  }

  function filterIntact(set) {
    const nodes = [...slideNodes(), ...gridNodes()];
    if (!nodes.length) return false;
    if (!set.size) return nodes.every((n) => !isSlideShown(n));
    for (const node of nodes) {
      const id = normMediaId(node.getAttribute("data-gordonix-media-id"));
      const should = set.has(id);
      if (should !== isSlideShown(node)) return false;
    }
    // En az bir görünür olmalı
    if (![...slideNodes()].some(isSlideShown)) return false;
    return true;
  }

  function markGalleryFiltering(list) {
    document.querySelectorAll("media-gallery").forEach((g) => {
      g.setAttribute("data-gordonix-filtering", list.length ? "1" : "0");
      g.setAttribute("data-gordonix-allowed", list.join(","));
    });
  }

  function applyFilter(ids, opts) {
    const mode = (opts && opts.mode) || "none";
    const force = !!(opts && opts.force);
    const map = parseMap();
    let list = (ids || []).map(normMediaId).filter(Boolean);
    // Boş liste: tek varyantta overview; çoklu varyantta ASLA tüm medya
    if (!list.length) {
      if (map.singleVariant) list = (map.overview || []).map(normMediaId).filter(Boolean);
      else {
        const vid = normMediaId(currentVariantId() || lockedVariantId || lastAppliedId);
        const variants = map.variants || {};
        let fb = variants[vid];
        if (!fb) {
          const key = Object.keys(variants).find((k) => normMediaId(k) === vid);
          if (key) fb = variants[key];
        }
        if (fb && fb.length) list = fb.map(normMediaId).filter(Boolean);
      }
    }
    const set = new Set(list);
    const key = list.join(",") + "|" + mode + "|" + (selectedMediaId || "");
    // Tema morph/select hidden'ı silince aynı key ile atlama — DOM bozulmuşsa zorla uygula
    if (!force && mode === "none" && key === lastFilterKey && !switching && filterIntact(set)) {
      syncSingleMediaUI();
      return;
    }
    lastFilterKey = key;
    applyingFilter = true;

    pinPageScroll(() => {
      // reveal kalıntılarını temizle (Horizon gizli slaytı tekrar gösterir)
      for (const node of slideNodes()) node.removeAttribute("reveal");

      // Önce show bayrakları — filtering attribute'tan ÖNCE (CSS yarışı olmasın)
      for (const node of [...slideNodes(), ...gridNodes(), ...zoomMediaNodes()]) {
        const id = normMediaId(node.getAttribute("data-gordonix-media-id"));
        setSlideVisible(node, set.size > 0 && set.has(id));
      }
      for (const thumb of thumbnailNodes()) {
        const id = normMediaId(thumb.getAttribute("data-gordonix-media-id"));
        setThumbVisible(thumb, set.size > 0 && set.has(id));
      }

      // Masaüstü: DOM sırasını hizala. Mobilde reorder sayfa zıplatır.
      if (!isMobileViewport() && (mode === "first" || force)) {
        reorderSlidesByIds(list);
        reorderThumbsByIds(list);
      }

      markGalleryFiltering(list);
      syncSingleMediaUI();

      if (mode === "none") {
        ensureActiveVisibleSlide({ force: true });
        applyingFilter = false;
        return;
      }

      const visible = slideNodes().filter(isSlideShown);
      if (!visible.length) {
        applyingFilter = false;
        return;
      }

      let target = null;
      if (mode === "keep" && selectedMediaId) {
        target = visible.find(
          (s) =>
            normMediaId(s.getAttribute("data-gordonix-media-id")) ===
            normMediaId(selectedMediaId)
        );
      }
      if (!target) target = visible[0];
      selectedMediaId = target.getAttribute("data-gordonix-media-id") || selectedMediaId;
      selectSlide(target, 0, { force: true });
      hardScrollToSlide(target);
      applyingFilter = false;
    });
  }

  function firstVisibleImg() {
    const prefer = selectedMediaId
      ? slideNodes().find(
          (s) =>
            isSlideShown(s) &&
            normMediaId(s.getAttribute("data-gordonix-media-id")) === normMediaId(selectedMediaId)
        )
      : null;
    const slide = prefer || slideNodes().find(isSlideShown);
    return slide ? slide.querySelector("img") : null;
  }

  function waitImageReady(img, timeoutMs) {
    return new Promise((resolve) => {
      if (!img) {
        resolve();
        return;
      }
      if (img.complete && img.naturalWidth > 0) {
        resolve();
        return;
      }
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        resolve();
      };
      img.addEventListener("load", finish, { once: true });
      img.addEventListener("error", finish, { once: true });
      setTimeout(finish, timeoutMs || 400);
      try {
        if (img.loading === "lazy") img.loading = "eager";
        const src = img.currentSrc || img.src;
        if (src) {
          const pre = new Image();
          pre.onload = finish;
          pre.onerror = finish;
          pre.src = src;
        }
      } catch (e) {}
    });
  }

  async function revealAfterReady(token) {
    try {
      gordonixForceEagerVisible();
    } catch (e) {}
    const img = firstVisibleImg();
    if (img && img.complete && img.naturalWidth > 0) {
      if (token === applyToken) hideSkeleton();
      return;
    }
    await waitImageReady(img, 220);
    if (token !== applyToken) return;
    hideSkeleton();
  }

  function showVariant(variantId, opts) {
    const withSkeleton = opts && opts.skeleton;
    const map = parseMap();
    const id = variantId
      ? String(variantId)
      : currentVariantId() ||
        (map.firstVariantId ? String(map.firstVariantId) : null);
    if (!id) {
      hideSkeleton();
      return false;
    }

    if (id === lastAppliedId && !withSkeleton && !switching) {
      applyFilter(variantImageIds(id), { mode: "none" });
      markReady();
      return true;
    }

    lockSwitch(isMobileViewport() ? 400 : 900);
    // Mobilde skeleton geçişi yavaşlatır ve kaydırırken zıplatır
    if (!isMobileViewport() && (withSkeleton || switching || id !== lastAppliedId)) {
      showSkeleton();
    }

    const token = ++applyToken;
    lockedVariantId = id;
    lastAppliedId = id;
    selectedMediaId = null;
    lastFilterKey = "";
    lastSingle = null;
    applyFilter(variantImageIds(id), { mode: "first", force: true });
    revealAfterReady(token);

    const retrySchedule = isMobileViewport()
      ? [50, 180]
      : [40, 120, 280, 500];
    retrySchedule.forEach((ms) => {
      setTimeout(() => {
        if (token !== applyToken) return;
        pinPageScroll(() => {
          applyFilter(variantImageIds(id), { mode: "first", force: true });
        });
      }, ms);
    });

    clearTimeout(skeletonTimer);
    skeletonTimer = setTimeout(() => {
      if (token === applyToken) hideSkeleton();
    }, isMobileViewport() ? 280 : 700);

    return true;
  }

  function onVariantSwitch() {
    const before = String(lastAppliedId || currentVariantId() || "");
    const my = ++switchToken;
    let tries = 0;
    const tick = () => {
      if (my !== switchToken) return;
      const live = currentVariantId();
      if (live && live !== before) {
        showVariant(live, { skeleton: !gordonixVisibleImgsReady() });
        return;
      }
      if (tries++ < 40) {
        setTimeout(tick, 12);
        return;
      }
      showVariant(live || before || null, { skeleton: false });
    };
    tick();
  }

  function reassertVisibility() {
    if (isSwitchLocked() || applyingFilter) return;
    const stuck = document.querySelector(
      "media-gallery.gordonix-has-skeleton .gordonix-gallery-skeleton.is-visible"
    );
    if (stuck && !switching) forceClearSkeleton();
    const id = currentVariantId() || lockedVariantId || lastAppliedId;
    if (!id) {
      markReady();
      return;
    }
    if (!slideNodes().length) {
      clearTimeout(morphTimer);
      morphTimer = setTimeout(reassertVisibility, 40);
      return;
    }
    lockedVariantId = id;
    const ids = variantImageIds(id);
    const set = new Set((ids || []).map(normMediaId).filter(Boolean));
    // Filtre zaten sağlamsa sadece aktif slaytı doğrula (swipe'ı bozma)
    if (!switching && set.size && filterIntact(set)) {
      // Yanlış aktif / reveal sızıntısı varsa düzelt
      const leaked = slideNodes().some(
        (s) =>
          !isSlideShown(s) &&
          (s.hasAttribute("reveal") || s.getAttribute("aria-hidden") === "false")
      );
      if (!leaked) {
        ensureActiveVisibleSlide({ force: false });
        markReady();
        return;
      }
    }
    if (ids.length) applyFilter(ids, { mode: isMobileViewport() ? "none" : "first", force: true });
    else if (!parseMap().singleVariant) applyFilter([], { mode: "none", force: true });
    markReady();
  }

  function findRadio(target) {
    if (!target || !target.closest) return null;
    if (target.matches?.('input[type="radio"]')) return target;
    const label = target.closest("label");
    if (!label) return null;
    if (label.htmlFor) {
      const el = document.getElementById(label.htmlFor);
      if (el && el.type === "radio") return el;
    }
    return label.querySelector('input[type="radio"]');
  }

  function onPickerInteract(e) {
    const picker = e.target.closest?.("variant-picker");
    if (!picker) return;
    const radio = findRadio(e.target);
    if (!radio) return;

    if (e.type === "pointerdown" && !radio.checked) {
      if (!isMobileViewport()) showSkeleton();
      return;
    }
    if (e.type === "change") {
      const picked = String(radio.dataset.variantId || "");
      if (picked && radio.checked) {
        pendingVariantId = picked;
        pendingVariantAt = Date.now();
      }
      onVariantSwitch();
    }
  }

  function onIdInput(e) {
    const t = e.target;
    if (!t || t.name !== "id") return;
    if (
      !t.closest("product-form-component") &&
      !t.closest('form[action*="/cart/add"]')
    ) {
      return;
    }
    const id = String(t.value || "");
    if (!id) return;
    if (id === lastAppliedId && !switching) return;
    switchToken += 1;
    showVariant(id, { skeleton: switching || id !== lastAppliedId });
  }

  function bindGalleryLoop() {
    if (document.documentElement.dataset.gordonixLoopBound === "1") return;
    document.documentElement.dataset.gordonixLoopBound = "1";
    document.addEventListener(
      "click",
      (e) => {
        const btn = e.target.closest?.(
          'media-gallery .slideshow-control--next, media-gallery .slideshow-control--previous, media-gallery button[ref="next"], media-gallery button[ref="previous"]'
        );
        if (!btn) return;
        const gallery = btn.closest("media-gallery");
        if (!gallery) return;
        const visible = slideNodes().filter(
          (s) => gallery.contains(s) && isSlideShown(s)
        );
        if (visible.length < 2) return;
        const activeIdx = visible.findIndex(
          (s) => s.getAttribute("aria-hidden") === "false"
        );
        const idx = activeIdx < 0 ? 0 : activeIdx;
        const isNext =
          btn.classList.contains("slideshow-control--next") ||
          btn.getAttribute("ref") === "next";
        const isPrev =
          btn.classList.contains("slideshow-control--previous") ||
          btn.getAttribute("ref") === "previous";
        if (isNext && idx >= visible.length - 1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          selectSlide(visible[0]);
          selectedMediaId = visible[0].getAttribute("data-gordonix-media-id");
          syncCounter();
        } else if (isPrev && idx <= 0) {
          e.preventDefault();
          e.stopImmediatePropagation();
          selectSlide(visible[visible.length - 1]);
          selectedMediaId = visible[visible.length - 1].getAttribute(
            "data-gordonix-media-id"
          );
          syncCounter();
        }
      },
      true
    );
  }

  // Varyant değişiminde tema media-gallery'yi yeniden oluşturur → document'a bağla
  function bindGalleryOpen() {
    if (document.documentElement.dataset.gordonixOpenBound === "1") return;
    document.documentElement.dataset.gordonixOpenBound = "1";
    document.addEventListener(
      "click",
      (e) => {
        if (!e.target.closest?.("media-gallery")) return;
        // Ana görsele tık → bizim lightbox (zoom'lu)
        const media = e.target.closest?.(
          "slideshow-slide .product-media, slideshow-slide img, .product-media img, .product-media"
        );
        if (!media) return;
        // thumbnail tıklaması değil
        if (e.target.closest?.(".slideshow-controls__thumbnail")) return;
        const slide = e.target.closest?.("slideshow-slide[data-gordonix-media-id], [data-gordonix-media-id]");
        const mid = slide
          ? slide.getAttribute("data-gordonix-media-id")
          : selectedMediaId;
        e.preventDefault();
        e.stopPropagation();
        openVariantLightbox(mid);
      },
      true
    );
  }

  function bindThumbClicks() {
    if (document.documentElement.dataset.gordonixThumbBound === "1") return;
    document.documentElement.dataset.gordonixThumbBound = "1";
    document.addEventListener(
      "click",
      (e) => {
        const thumb = e.target.closest?.(
          "media-gallery .slideshow-controls__thumbnail[data-gordonix-media-id]"
        );
        if (
          !thumb ||
          thumb.classList.contains("gordonix-thumb-hide") ||
          thumb.hidden
        )
          return;
        const id = thumb.getAttribute("data-gordonix-media-id");
        if (!id) return;
        selectedMediaId = String(id);
        const slide =
          document.querySelector(
            'media-gallery slideshow-slide[slide-id="' + id + '"]'
          ) ||
          document.querySelector(
            'media-gallery slideshow-slide[data-gordonix-media-id="' + id + '"]'
          );
        if (!slide || slide.hasAttribute("hidden")) return;
        // Horizon native de çalışsın; ekstra select güvenilirlik için
        selectSlide(slide);
      },
      true
    );
  }

  function watchCounterUpdates() {
    document.querySelectorAll("media-gallery .slideshow-controls__counter [ref='current']").forEach((el) => {
      if (el.dataset.gordonixCounterWatch === "1") return;
      el.dataset.gordonixCounterWatch = "1";
      new MutationObserver(() => {
        if (counterSyncing || applyingFilter || switching) return;
        clearTimeout(counterTimer);
        counterTimer = setTimeout(syncCounter, 50);
      }).observe(el, { characterData: true, childList: true, subtree: true });
    });
  }

  function watchGalleryMorph() {
    const gallery = document.querySelector("media-gallery");
    if (!gallery) return;
    if (galleryObserver) {
      try {
        galleryObserver.disconnect();
      } catch (e) {}
    }
    galleryObserver = new MutationObserver(() => {
      if (applyingFilter || switching || isSwitchLocked()) return;
      clearTimeout(morphTimer);
      morphTimer = setTimeout(() => {
        if (applyingFilter || switching || isSwitchLocked()) return;
        reassertVisibility();
      }, isMobileViewport() ? 160 : 60);
    });
    galleryObserver.observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true,
      // Mobilde aria-hidden/style her swipe'ta değişir → eski görsel yarışı; izleme
      attributeFilter: isMobileViewport()
        ? ["hidden", "class", "data-gordonix-show"]
        : ["hidden", "class", "style", "aria-hidden", "reveal", "data-gordonix-show"],
    });

    // Zoom dialog açılınca varyant filtresini uygula
    document.querySelectorAll("zoom-dialog dialog").forEach((dlg) => {
      if (dlg.dataset.gordonixZoomWatch === "1") return;
      dlg.dataset.gordonixZoomWatch = "1";
      new MutationObserver(() => {
        if (dlg.hasAttribute("open") || dlg.open) {
          const id = currentVariantId() || lockedVariantId || lastAppliedId;
          if (id) applyFilter(variantImageIds(id), { mode: "none" });
        }
      }).observe(dlg, { attributes: true, attributeFilter: ["open"] });
    });
  }

  // Tema varyant değişiminde media-gallery'yi yeniden oluşturur; geç gelen yeni galeriye filtreyi tekrar uygula
  let knownGallery = null;
  function onGalleryReplaced() {
    const id = currentVariantId() || lockedVariantId || lastAppliedId;
    if (!id) return;
    watchGalleryMorph();
    watchCounterUpdates();
    lastFilterKey = "";
    pinPageScroll(() => {
      applyFilter(variantImageIds(id), {
        mode: isMobileViewport() ? "none" : "first",
        force: true,
      });
    });
    markReady();
  }
  function watchGalleryReplace() {
    if (document.documentElement.dataset.gordonixReplaceWatch === "1") return;
    document.documentElement.dataset.gordonixReplaceWatch = "1";
    knownGallery = document.querySelector("media-gallery");
    new MutationObserver(() => {
      const mg = document.querySelector("media-gallery");
      if (!mg || mg === knownGallery) return;
      knownGallery = mg;
      // Senkron: yeni galeri filtresiz bir kare boyanırsa tüm thumbnail'lar yanıp söner
      onGalleryReplaced();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function syncLookThumbs() {
    const strip = document.querySelector(".gordonix-look-lb__thumbs");
    if (!strip) return;
    strip.querySelectorAll(".gordonix-look-lb__thumb").forEach((btn, i) => {
      btn.classList.toggle("is-active", i === lookIndex);
    });
  }

  let zoomScale = 1;
  let zoomX = 0;
  let zoomY = 0;
  let zoomDragging = false;
  let zoomLastX = 0;
  let zoomLastY = 0;
  let zoomPointerMoved = false;
  let zoomPointerStartX = 0;
  let zoomPointerStartY = 0;
  let pinchStartDist = 0;
  let pinchStartScale = 1;

  function resetZoom() {
    zoomScale = 1;
    zoomX = 0;
    zoomY = 0;
    const lb = document.getElementById("gordonix-look-lightbox");
    if (!lb) return;
    const img = lb.querySelector(".gordonix-look-lb__img");
    const stage = lb.querySelector(".gordonix-look-lb__stage");
    if (img) {
      img.style.transform = "";
      // Geçiş flash'ını önlemek için opacity'yi burada zorla açma
    }
    if (stage) stage.classList.remove("is-zoomed");
    lb.classList.remove("is-zoomed");
  }

  function applyZoom() {
    const lb = document.getElementById("gordonix-look-lightbox");
    if (!lb) return;
    const img = lb.querySelector(".gordonix-look-lb__img");
    const stage = lb.querySelector(".gordonix-look-lb__stage");
    if (!img) return;
    if (zoomScale < 1.02) {
      zoomScale = 1;
      zoomX = 0;
      zoomY = 0;
    }
    img.style.transform =
      "translate(" + zoomX + "px," + zoomY + "px) scale(" + zoomScale + ")";
    const zoomed = zoomScale > 1.02;
    if (stage) stage.classList.toggle("is-zoomed", zoomed);
    lb.classList.toggle("is-zoomed", zoomed);
  }

  // Tıklanan noktaya doğru zoom (masaüstü)
  function zoomToward(clientX, clientY, newScale) {
    const lb = document.getElementById("gordonix-look-lightbox");
    if (!lb) return;
    const img = lb.querySelector(".gordonix-look-lb__img");
    if (!img) return;
    const rect = img.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const prev = zoomScale < 1.02 ? 1 : zoomScale;
    const next = Math.min(5, Math.max(1, newScale));
    if (next <= 1.02) {
      resetZoom();
      return;
    }
    const ox = clientX - cx;
    const oy = clientY - cy;
    // İmleç altındaki nokta sabit kalsın
    zoomX = zoomX + ox * (1 - next / prev);
    zoomY = zoomY + oy * (1 - next / prev);
    zoomScale = next;
    applyZoom();
  }

  function bindZoom(lb) {
    if (lb.dataset.gordonixZoomBound === "1") return;
    lb.dataset.gordonixZoomBound = "1";
    const stage = lb.querySelector(".gordonix-look-lb__stage");
    const img = lb.querySelector(".gordonix-look-lb__img");
    if (!stage || !img) return;

    stage.addEventListener(
      "wheel",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        const delta = e.deltaY > 0 ? -0.18 : 0.18;
        const next = Math.min(5, Math.max(1, zoomScale + delta));
        if (next <= 1.02) {
          resetZoom();
          return;
        }
        zoomToward(e.clientX, e.clientY, next);
      },
      { passive: false }
    );

    // Görsele tık → zoom in/out. Zoomdayken 2. tık ASLA kapatmaz.
    stage.addEventListener("click", (e) => {
      if (e.target.closest?.(".gordonix-look-lb__nav, .gordonix-look-lb__close"))
        return;
      if (zoomPointerMoved) return;

      const onImg = !!e.target.closest?.(".gordonix-look-lb__img");

      // Zoom açık: her tık (görsel/stage) → zoom out
      if (zoomScale > 1.05) {
        e.preventDefault();
        e.stopPropagation();
        resetZoom();
        return;
      }

      // Zoom kapalı: sadece görsele tık → zoom in (masaüstü)
      if (!onImg) return;
      if (!window.matchMedia("(min-width: 750px)").matches) return;
      e.preventDefault();
      e.stopPropagation();
      zoomToward(e.clientX, e.clientY, 2.6);
    });

    stage.addEventListener("dblclick", (e) => {
      // Tek tık zaten zoom yapıyor; çift tıkın ekstra etkisi olmasın
      e.preventDefault();
      e.stopPropagation();
    });

    stage.addEventListener("pointerdown", (e) => {
      if (e.button != null && e.button !== 0) return;
      zoomPointerMoved = false;
      zoomPointerStartX = e.clientX;
      zoomPointerStartY = e.clientY;
      zoomLastX = e.clientX;
      zoomLastY = e.clientY;
      if (zoomScale <= 1.02) return;
      zoomDragging = true;
      try {
        stage.setPointerCapture(e.pointerId);
      } catch (err) {}
    });
    stage.addEventListener("pointermove", (e) => {
      const dx = e.clientX - zoomPointerStartX;
      const dy = e.clientY - zoomPointerStartY;
      if (Math.hypot(dx, dy) > 6) zoomPointerMoved = true;
      if (!zoomDragging) return;
      zoomX += e.clientX - zoomLastX;
      zoomY += e.clientY - zoomLastY;
      zoomLastX = e.clientX;
      zoomLastY = e.clientY;
      applyZoom();
    });
    const endDrag = () => {
      zoomDragging = false;
    };
    stage.addEventListener("pointerup", endDrag);
    stage.addEventListener("pointercancel", endDrag);

    stage.addEventListener(
      "touchstart",
      (e) => {
        if (e.touches.length === 2) {
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          pinchStartDist = Math.hypot(dx, dy);
          pinchStartScale = zoomScale;
        }
      },
      { passive: true }
    );
    stage.addEventListener(
      "touchmove",
      (e) => {
        if (e.touches.length === 2 && pinchStartDist > 0) {
          e.preventDefault();
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          const dist = Math.hypot(dx, dy);
          zoomScale = Math.min(
            5,
            Math.max(1, pinchStartScale * (dist / pinchStartDist))
          );
          applyZoom();
        }
      },
      { passive: false }
    );
    stage.addEventListener(
      "touchend",
      () => {
        pinchStartDist = 0;
      },
      { passive: true }
    );
  }

  function collectItemsFromIds(ids) {
    const items = [];
    const limit = Math.min(ids.length, 24);
    for (let i = 0; i < limit; i++) {
      const id = String(ids[i]);
      const media = mediaImgForId(id);
      if (!media || !media.thumb) continue;
      items.push({
        id,
        thumb: media.thumb,
        full: media.full,
        w: media.w,
        h: media.h,
        label: "Görsel " + (items.length + 1),
      });
    }
    return items;
  }

  function openLightbox(items, startIndex) {
    if (!items || !items.length) return;
    lookItems = items.map((it, i) => ({
      ...it,
      label: it.label || "Görsel " + (i + 1),
    }));
    rebuildLookThumbs();
    showLookAt(startIndex || 0);
  }

  function openVariantLightbox(startMediaId) {
    const ids = variantImageIds(currentVariantId() || lastAppliedId);
    const items = collectItemsFromIds(ids);
    if (!items.length) return;
    let idx = 0;
    if (startMediaId) {
      const found = items.findIndex(
        (x) => String(x.id) === String(startMediaId)
      );
      if (found >= 0) idx = found;
    }
    openLightbox(items, idx);
  }

  function ensureLightbox() {
    let lb = document.getElementById("gordonix-look-lightbox");
    // Eski DOM (nav stage içinde) → yeniden kur
    if (lb && !lb.querySelector(":scope > .gordonix-look-lb__next")) {
      lb.remove();
      lb = null;
    }
    if (lb) {
      bindZoom(lb);
      return lb;
    }
    lb = document.createElement("div");
    lb.id = "gordonix-look-lightbox";
    lb.className = "gordonix-look-lb";
    lb.hidden = true;
    lb.innerHTML =
      '<button type="button" class="gordonix-look-lb__close" aria-label="Kapat">×</button>' +
      '<button type="button" class="gordonix-look-lb__nav gordonix-look-lb__prev" aria-label="Önceki">‹</button>' +
      '<button type="button" class="gordonix-look-lb__nav gordonix-look-lb__next" aria-label="Sonraki">›</button>' +
      '<div class="gordonix-look-lb__stage">' +
      '<img class="gordonix-look-lb__img" alt="" />' +
      "</div>" +
      '<div class="gordonix-look-lb__thumbs" role="list"></div>';
    document.body.appendChild(lb);
    lb.querySelector(".gordonix-look-lb__close").addEventListener("click", (e) => {
      e.stopPropagation();
      closeLook();
    });
    // Karanlık boş alana tık → kapat. Zoomdayken önce zoom out.
    lb.addEventListener("click", (e) => {
      if (
        e.target.closest?.(
          ".gordonix-look-lb__nav, .gordonix-look-lb__close, .gordonix-look-lb__thumbs, .gordonix-look-lb__thumb"
        )
      ) {
        return;
      }
      if (zoomScale > 1.05) {
        e.preventDefault();
        e.stopPropagation();
        resetZoom();
        return;
      }
      // Görsel / stage tıkı zoom handler'da
      if (e.target.closest?.(".gordonix-look-lb__img, .gordonix-look-lb__stage")) {
        return;
      }
      closeLook();
    });
    const goPrev = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (lookItems.length < 2) return;
      showLookAt(lookIndex - 1);
    };
    const goNext = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (lookItems.length < 2) return;
      showLookAt(lookIndex + 1);
    };
    lb.querySelector(".gordonix-look-lb__prev").addEventListener("click", goPrev);
    lb.querySelector(".gordonix-look-lb__next").addEventListener("click", goNext);
    lb.querySelector(".gordonix-look-lb__prev").addEventListener("pointerdown", (e) => e.stopPropagation());
    lb.querySelector(".gordonix-look-lb__next").addEventListener("pointerdown", (e) => e.stopPropagation());
    lb.querySelector(".gordonix-look-lb__thumbs").addEventListener("click", (e) => {
      const btn = e.target.closest?.(".gordonix-look-lb__thumb");
      if (!btn) return;
      e.stopPropagation();
      const idx = Number(btn.getAttribute("data-index"));
      if (!Number.isNaN(idx)) showLookAt(idx);
    });
    let sx = 0;
    const stage = lb.querySelector(".gordonix-look-lb__stage");
    stage.addEventListener(
      "touchstart",
      (e) => {
        if (e.touches.length === 1 && zoomScale <= 1.02) {
          sx = e.changedTouches[0].clientX;
        }
      },
      { passive: true }
    );
    stage.addEventListener(
      "touchend",
      (e) => {
        if (zoomScale > 1.02) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) showLookAt(lookIndex + 1);
        else showLookAt(lookIndex - 1);
      },
      { passive: true }
    );
    document.addEventListener("keydown", (e) => {
      if (lb.hidden) return;
      if (e.key === "Escape") closeLook();
      if (e.key === "ArrowRight" && lookItems.length > 1) {
        showLookAt(lookIndex + 1);
      }
      if (e.key === "ArrowLeft" && lookItems.length > 1) {
        showLookAt(lookIndex - 1);
      }
    });
    bindZoom(lb);
    return lb;
  }

  function rebuildLookThumbs() {
    const lb = ensureLightbox();
    const strip = lb.querySelector(".gordonix-look-lb__thumbs");
    if (!strip) return;
    strip.innerHTML = "";
    lookItems.forEach((item, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gordonix-look-lb__thumb";
      btn.setAttribute("data-index", String(i));
      btn.setAttribute("aria-label", item.label || "Görsel " + (i + 1));
      const img = document.createElement("img");
      img.src = item.thumb;
      img.alt = "";
      img.loading = "lazy";
      btn.appendChild(img);
      strip.appendChild(btn);
    });
    syncLookThumbs();
  }

  function scrollActiveThumbIntoStrip(lb) {
    const strip = lb.querySelector(".gordonix-look-lb__thumbs");
    const active = lb.querySelector(".gordonix-look-lb__thumb.is-active");
    if (!strip || !active) return;
    // Sayfa kaymasın — sadece alt şerit içinde hizala
    const stripRect = strip.getBoundingClientRect();
    const btnRect = active.getBoundingClientRect();
    const pad = 12;
    let delta = 0;
    if (btnRect.left < stripRect.left + pad) {
      delta = btnRect.left - stripRect.left - pad;
    } else if (btnRect.right > stripRect.right - pad) {
      delta = btnRect.right - stripRect.right + pad;
    }
    if (delta) strip.scrollLeft += delta;
  }

  let lookSwapToken = 0;

  function wrapLookIndex(index) {
    const n = lookItems.length;
    if (n < 1) return 0;
    return ((Number(index) % n) + n) % n;
  }

  function showLookAt(index) {
    if (!lookItems.length) return;
    lookIndex = wrapLookIndex(index);
    const item = lookItems[lookIndex];
    if (!item) return;
    const lb = ensureLightbox();
    const img = lb.querySelector(".gordonix-look-lb__img");
    const stage = lb.querySelector(".gordonix-look-lb__stage");
    const nextSrc = item.full || item.thumb || "";
    const prevSrc = img.getAttribute("src") || "";
    img.alt = item.label || "";

    resetZoom();

    const token = ++lookSwapToken;
    const setLoading = (on) => {
      if (stage) stage.classList.toggle("is-loading", on);
    };
    const applySrc = () => {
      if (token !== lookSwapToken) return;
      img.style.transition = "none";
      img.style.transform = "";
      img.style.opacity = "1";
      if ((img.getAttribute("src") || "") !== nextSrc) {
        img.src = nextSrc;
      }
      setLoading(false);
    };

    if (nextSrc && prevSrc !== nextSrc) {
      const pre = new Image();
      pre.onload = applySrc;
      pre.onerror = applySrc;
      pre.src = nextSrc;
      if (pre.complete && pre.naturalWidth > 0) {
        applySrc();
      } else {
        // Yüksek çözünürlük gelene kadar: sayfadaki yüklü görsel, yoksa oran kadar skeleton
        const low = new Image();
        low.src = item.thumb || "";
        if (item.thumb && low.complete && low.naturalWidth > 0) {
          img.src = item.thumb;
          setLoading(false);
        } else {
          const w = item.w || 1000;
          const h = item.h || 1000;
          img.src =
            "data:image/svg+xml;charset=utf-8," +
            encodeURIComponent(
              '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '"></svg>'
            );
          setLoading(true);
        }
      }
    } else {
      applySrc();
    }

    lb.hidden = false;
    lb.setAttribute("data-look-index", String(lookIndex));
    lb.setAttribute("data-look-count", String(lookItems.length));
    document.documentElement.classList.add("gordonix-look-open");
    const multi = lookItems.length > 1;
    const prev = lb.querySelector(".gordonix-look-lb__prev");
    const next = lb.querySelector(".gordonix-look-lb__next");
    if (prev) {
      prev.style.display = multi ? "" : "none";
      prev.disabled = false;
      prev.removeAttribute("aria-disabled");
    }
    if (next) {
      next.style.display = multi ? "" : "none";
      next.disabled = false;
      next.removeAttribute("aria-disabled");
    }
    syncLookThumbs();
    scrollActiveThumbIntoStrip(lb);
  }

  function closeLook() {
    const lb = document.getElementById("gordonix-look-lightbox");
    if (lb) lb.hidden = true;
    document.documentElement.classList.remove("gordonix-look-open");
    resetZoom();
  }

  function isDesktopLook() {
    return window.matchMedia("(min-width: 750px)").matches;
  }

  function placeLookRoot(root) {
    const gallery = document.querySelector("media-gallery");
    // Masaüstü: ürün görsel galerisinin hemen altına
    if (isDesktopLook() && gallery) {
      gallery.insertAdjacentElement("afterend", root);
      return;
    }
    // Mobil: mevcut yerleşim (Ürün Özellikleri sonrası)
    const spec = document.querySelector(".gordonix-spec-table");
    if (spec) {
      spec.insertAdjacentElement("afterend", root);
      return;
    }
    const details = document.querySelector(
      ".product-details, [data-testid='product-information-details']"
    );
    if (details) {
      details.appendChild(root);
      return;
    }
    if (gallery) gallery.insertAdjacentElement("afterend", root);
  }

  function relocateLookStrip() {
    const root = document.querySelector("[data-gordonix-look]");
    if (!root) return;
    placeLookRoot(root);
  }

  function buildLookStrip() {
    const map = parseMap();
    const ids = (map.overview || []).map(String);
    if (ids.length < 1) return;
    if (!document.querySelector("media-gallery")) return;

    document.querySelectorAll("[data-gordonix-look]").forEach((el) => el.remove());

    const items = collectItemsFromIds(ids);
    if (!items.length) return;

    const root = document.createElement("div");
    root.className = "gordonix-look";
    root.setAttribute("data-gordonix-look", "");
    root.innerHTML =
      '<div class="gordonix-look__header"><h3 class="gordonix-look__title">Yakından bak</h3></div>' +
      '<div class="gordonix-look__grid"></div>';
    placeLookRoot(root);

    const grid = root.querySelector(".gordonix-look__grid");
    lookItems = [];
    items.forEach((item, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gordonix-look__item";
      btn.setAttribute("data-media-id", item.id);
      btn.setAttribute("data-index", String(i));
      btn.setAttribute("aria-label", item.label || "Görsel " + (i + 1));
      const img = document.createElement("img");
      img.src = item.thumb;
      img.alt = "";
      img.loading = "lazy";
      img.decoding = "async";
      btn.appendChild(img);
      grid.appendChild(btn);
      lookItems.push({ ...item, el: btn });
    });

    rebuildLookThumbs();

    root.addEventListener("click", (e) => {
      const btn = e.target.closest?.(".gordonix-look__item");
      if (!btn) return;
      e.preventDefault();
      const idx = Number(btn.getAttribute("data-index") || 0);
      openLightbox(
        lookItems.map(({ id, thumb, full, label }) => ({
          id,
          thumb,
          full,
          label,
        })),
        idx
      );
    });
  }


  function init() {
    markReady();
    try { gordonixForceEagerVisible(); } catch (e) {}
    bindThumbClicks();
    bindGalleryOpen();
    bindGalleryLoop();
    watchGalleryMorph();
    watchGalleryReplace();
    watchCounterUpdates();
    buildLookStrip();
    showVariant(currentVariantId(), { skeleton: false });
    markReady();
  }

  function bootstrap() {
    if (bootstrapped) return;
    bootstrapped = true;
    // Mobil scroll sonrası takılı skeleton güvenliği
    let scrollSafety;
    window.addEventListener(
      "scroll",
      () => {
        clearTimeout(scrollSafety);
        scrollSafety = setTimeout(() => {
          if (switching) return;
          const stuck = document.querySelector(
            "media-gallery.gordonix-has-skeleton .gordonix-gallery-skeleton.is-visible"
          );
          if (stuck) forceClearSkeleton();
        }, 200);
      },
      { passive: true }
    );
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && !switching) forceClearSkeleton();
    });
    window.addEventListener("pageshow", () => {
      if (!switching) forceClearSkeleton();
    });
    // Masaüstü/mobil: Yakından bak konumunu ayır
    let lookPlaceTimer;
    window.addEventListener("resize", () => {
      clearTimeout(lookPlaceTimer);
      lookPlaceTimer = setTimeout(relocateLookStrip, 150);
    });
    // Marker: gordonix-look-relocate
    // Marker: gordonix-skeleton-safety

    document.addEventListener("pointerdown", onPickerInteract, true);
    document.addEventListener("change", onPickerInteract, true);
    document.addEventListener("input", onIdInput, true);

    document.addEventListener("DOMContentLoaded", () => setTimeout(init, 30));
    document.addEventListener("shopify:section:load", () => setTimeout(init, 40));

    document.addEventListener("product:selected", () => {
      setTimeout(() => {
        document.querySelectorAll("zoom-dialog dialog").forEach((d) => {
          d.dataset.gordonixZoomWatch = "";
        });
        bindThumbClicks();
        bindGalleryOpen();
        watchGalleryMorph();
        watchCounterUpdates();
        buildLookStrip();
        const id = currentVariantId() || lockedVariantId || lastAppliedId;
        if (id) showVariant(id, { skeleton: switching });
        else hideSkeleton();
      }, 30);
    });

    document.addEventListener("variant:change", onVariantSwitch);
    document.addEventListener("product:variant-change", onVariantSwitch);

    setTimeout(() => markReady(), 150);

    if (document.readyState !== "loading") {
      showVariant(currentVariantId(), { skeleton: false });
      setTimeout(init, 30);
    }
  }

  bootstrap();
})();
